/** As telas do Administrativo dentro da Farm (02/11/2026): os mesmos configs de
 *  Usuários e Cargos, com o endereço trocado para `/farm/...`. Assim o lápis, o
 *  Novo e o Voltar da lista e do formulário continuam dentro do hub. As keys, as
 *  colunas e os formulários são os do HubTransGrãos, sem cópia. */
import { cargosConfig, usuariosConfig } from '../../features/cadastros/configs'

export const FARM_USUARIOS_PATH = '/farm/usuarios'
export const FARM_CARGOS_PATH = '/farm/cargos'

export const farmUsuariosConfig = { ...usuariosConfig, basePath: FARM_USUARIOS_PATH }
export const farmCargosConfig = { ...cargosConfig, basePath: FARM_CARGOS_PATH }
